import Error404Page from "components/404/Error404Page";
import { Route, Routes, useLocation } from "react-router-dom";
import MobileNumberSignIn from "routes/account/signIn/MobileNumberSignIn";
import AuthenticationFlow from "routes/account/signIn/AuthenticationFlow";
import MemberNumberSignUpAndSignIn from "routes/account/signUp/MemberNumberSignUpAndSignIn";
import MemberSignUp from "routes/account/signUp/MemberSignUp";
import VendingSignIn from "routes/front/main/vending/VendingSignIn";
import WebSocketContainer from "routes/front/main/WebSocketContainer";
import VendingComplete from "routes/front/mobile/complete/VendingComplete";
import Shopping from "routes/front/mobile/Shopping";

import { requester } from "App";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import MemberWithdrawal from "routes/account/withdrawal/MemberWithdrawal";
import Brand from "routes/front/mobile/brand/Brand";
import MobileLayout from "routes/front/mobile/MobileLayout";


import NotificationSettings from "components/settings/NotificationSettings";
import DoorAccessGateway from "modals/store/DoorAccessGateway";
import Main2 from "routes/front/mobile/Main2";
import NearbyStoreContainer from "routes/front/mobile/map/NearbyStoreContainer";
import Setting from "routes/front/mobile/Setting";
import OrderHistory from "routes/front/mobile/OrderHistory";
import PaymentHistoryGateway from "routes/front/mobile/payment/PaymentHistoryGateway";
import PaymentLanding from "routes/front/mobile/payment/PaymentLanding";
import PaymentLandingGateway from "routes/front/mobile/payment/PaymentLandingGateway";
import PolicyPage from "routes/front/mobile/policy/PolicyPage";
import PrivacyPolicy from "routes/front/mobile/policy/PrivacyPolicy";
import Receipt from "routes/front/mobile/receipt/Receipt";
import ReceiptDetail from "routes/front/mobile/receipt/ReceiptDetail";
import ProductReview from "routes/front/mobile/review/ProductReview";
import StoreList from "routes/front/mobile/store/StoreList";
import DoorSuccessPage from "routes/front/store/DoorSuccessPage";
import Payment2 from "routes/main/Payment2";
import PaymentComplete from "routes/main/PaymentComplete";
import PaymentCompleteSuccess from "routes/main/PaymentCompleteSuccess";
import PaymentFail from "routes/main/PaymentFail";
import PaymentGateway from "routes/main/PaymentGateway";
import BiometricAuthTest from "routes/main/test/BiometricAuthTest";
import QrTest from "routes/main/test/QrTest";
import TestPayment from "routes/main/TestPayment";
import TestPaymentGateway from "routes/main/TestPaymentGateway";
import { FavoriteReducer } from "shared/redux/reducers/shopping/FavoriteReducer";
import BiometricTest from "routes/main/test/BiometricTest";
import Profile from "routes/front/mobile/profile/Profile";
import BiometricTestIOS from "routes/main/test/BiometricTestIOS";
import AppDown from "routes/front/AppDown";
import CardAuthVerification from "modals/store/CardAuthVerification";






function FrontRouter({ allowedRoles }) {
    const location = useLocation();
    const { isAuthenticated } = useContext(AuthContext);
    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (isAuthenticated === true) {
    //         requester.findAllbyFavorites((result) => {
    //             if (result.code === 0) {
    //                 dispatch(FavoriteReducer.actions.refreshFavorites(result.data));
    //             }
    //         });
    //     } else {
    //         dispatch(FavoriteReducer.actions.reset());
    //     }
    // }, [isAuthenticated]);

    return (
        <Routes location={location}>
            <Route path="*" element={<Error404Page />} />
            <Route path="vendingComplete" element={<VendingComplete />} />
            <Route path="mobileNumber" element={<MobileNumberSignIn />} />
            <Route path="auth" element={<AuthenticationFlow />} />
            <Route path="memberAccess" element={<MemberNumberSignUpAndSignIn />} />
            <Route path="/signUp" element={<MemberSignUp />} />
            <Route path="/policy" element={<PolicyPage />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/brand" element={<Brand />} />
            <Route path="/qrtest" element={<QrTest />} />
            {/* <Route path="/biometrictest" element={<BiometricTest />} /> */}
            {/* <Route path="/biometrictestios" element={<BiometricTestIOS />} /> */}
            <Route path="/ws/:id" element={<WebSocketContainer />} >
                <Route path="paymentHistory" element={<PaymentHistoryGateway />} />
                <Route path="landing" element={<PaymentLanding />} />
                <Route path="landingGateWay" element={<PaymentLandingGateway />} />
                <Route path="vendingSignIn" element={<VendingSignIn />} />
                <Route path="policy" element={<PolicyPage />} />
                <Route path="privacy" element={<PrivacyPolicy />} />
                <Route path="door-success" element={<DoorSuccessPage />} />
                <Route path="test/passkey" element={<BiometricAuthTest />} />

                <Route path="mobile" element={<MobileLayout />}>
                    <Route path="main" element={<Main2 />} />
                    <Route path="storeList" element={<StoreList />} />
                    <Route path="settings" element={<Setting />} />
                    <Route path="settings/profile" element={<Profile />} />
                    <Route path="settings/notifications" element={<NotificationSettings />} />
                    <Route path="settings/policy" element={<PolicyPage />} />
                    <Route path="settings/privacy" element={<PrivacyPolicy />} />

                    <Route path="map" element={<NearbyStoreContainer />} />
                    <Route path="settings/withdrawal" element={<MemberWithdrawal />} />
                    <Route path="orderHistory" element={<OrderHistory />} />
                    <Route path="shopping" element={<Shopping />} />
                    <Route path="receipt">
                        <Route path="" element={<Receipt />} />
                        <Route path="detail/:orderId" element={<ReceiptDetail />} />
                        <Route path="review/:orderId" element={<ProductReview />} />
                    </Route>
                </Route>
                <Route path="testPayment">
                    <Route path="" element={<TestPayment />} />
                    <Route path="gateway" element={<TestPaymentGateway />} />
                </Route>


                <Route path="payment">
                    <Route path="" element={<Payment2 />} />
                    <Route path="gateway" element={<PaymentGateway />} />
                    <Route path="complete" element={<PaymentComplete />} />
                    <Route path="fail" element={<PaymentFail />} />
                    <Route path="success" element={<PaymentCompleteSuccess />} />
                </Route>
                <Route path="door-access/:iot_id" element={<DoorAccessGateway />} />
            </Route>
            <Route path="card-auth-verification" element={<CardAuthVerification />} />
            <Route path='/appDown' element={<AppDown />} />


        </Routes>
    );
}

export default FrontRouter;